import HistoricalDashboardPage from './HistoricalDashboardPage';
export { HistoricalDashboardPage };
export default HistoricalDashboardPage;
